const ACTION_KEY = 'REPORT_PATIENT_FULL';

const initialState = () => ({
  loading: false,
  professionalData: null,
  professionalSignature: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const { professionalData, professionalSignature, familySignature } = action.payload;
      return {
        ...state,
        loading: false,
        professionalData,
        professionalSignature,
        familySignature
      };
    }

    case `${ACTION_KEY}_IMPORT`: {
      const importData = action.payload;
      return {
        ...state,
        importData
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
